import { render, staticRenderFns } from "./EducationOtherCostsCostBearerPreview.vue?vue&type=template&id=36dc8b3c&scoped=true"
import script from "./EducationOtherCostsCostBearerPreview.vue?vue&type=script&lang=ts"
export * from "./EducationOtherCostsCostBearerPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc8b3c",
  null
  
)

export default component.exports